import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { interval, Subscription } from 'rxjs';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { MenuItemService } from 'src/app/services/menu.item.service';
import { OrderService } from 'src/app/services/order.service';
import { CONSTANTES, getToken } from 'src/app/shared/global';

declare var jQuery: any;

@Component({
  selector: 'app-menu-individual',
  templateUrl: './menu-individual.component.html',
  styleUrls: ['./menu-individual.component.scss']
})
export class MenuIndividualComponent implements OnInit {

  public fileUrl: any;
  public pdfarray: string;
  public mensajesUser: string[];
  public user: string;
  public role: string;
  public mensajesNoLeidos: string;
  public articulosGuardados: string;
  public statusOrder: string;
  public activeUser: string;
  public forcedChangePassword: string;
  public navImage = CONSTANTES.navBarImage;
  public menuImage = CONSTANTES.menuImage;
  public menuItems: string[] = [];
  public numberRole: number;

  public dateNow: Date = new Date();
  public dDay: Date;
  milliSecondsInASecond = 1000;
  hoursInADay = 24;
  minutesInAnHour = 60;
  SecondsInAMinute = 60;

  public timeDifference;
  public secondsToDday;
  public minutesToDday;
  public hoursToDday;
  public daysToDday;

  private subscriptionName: Subscription;
  private subscriptionTime: Subscription; //important to create a subscription
  private subscriptionDate: Subscription;
  private subscriptionStatus: Subscription;


  constructor(private menuItemService: MenuItemService, private router: Router,
    private authService: AuthenticationService, private orderService: OrderService) {

      this.subscriptionName= this.orderService.getUpdate().subscribe
      (message => { //message contains the data sent from service
        
        this.articulosGuardados = message;
      });

      this.subscriptionTime = this.orderService.valueTime.subscribe(time => {
        if (parseFloat(time) > 0) {
          var aux = time + "+" + (2 * 60 * 60 * 1000);
        
          this.dDay = new Date(aux.split("+")
            .map(parseFloat)
            .reduce(function (a, b) { return a + b; }));
          
        }
      })

      this.subscriptionStatus= this.orderService.status.subscribe
      (statusValue => { //message contains the data sent from service
        
        this.statusOrder = statusValue;
      });

     }
    

  pdfSrc="http://localhost/pcami/pdf/MANUAL_DE_USUARIO_"+localStorage.getItem("role")+".pdf"

  ngOnInit() {
    jQuery.getScript(CONSTANTES.menu);

    this.user = localStorage.getItem("nid");
    this.numberRole = +localStorage.getItem("numberRole");
    this.role = localStorage.getItem("role");
    if(this.articulosGuardados == null) {
      this.articulosGuardados = "0";
    }
    this.checkUserActive();

    // Obtenemos los menuItem a los que tiene permiso el usuario
    this.getMenuItems();

    this.subscriptionDate = interval(1000)
    .subscribe(x => { this.getTimeDifference(); });
}

private getTimeDifference() {
  if (this.dDay != null) {
    this.timeDifference = this.dDay.getTime() - new Date().getTime();
    this.allocateTimeUnits(this.timeDifference);
  }
}

private allocateTimeUnits(timeDifference) {
  this.secondsToDday = Math.floor((timeDifference) / (this.milliSecondsInASecond) % this.SecondsInAMinute);
  this.minutesToDday = Math.floor((timeDifference) / (this.milliSecondsInASecond * this.minutesInAnHour) % this.SecondsInAMinute);
  this.hoursToDday = Math.floor((timeDifference) / (this.milliSecondsInASecond * this.minutesInAnHour * this.SecondsInAMinute) % this.hoursInADay);
  this.daysToDday = Math.floor((timeDifference) / (this.milliSecondsInASecond * this.minutesInAnHour * this.SecondsInAMinute * this.hoursInADay));
}

  logOut() {
    let infoUser = {
      userName: localStorage.getItem("nid")
    }
    this.authService.logOut(infoUser).subscribe(
      data => {
        localStorage.clear();
        this.router.navigate(['login']);
      }
    );
  }

  checkUserActive() {
    this.activeUser = localStorage.getItem("active");
  }

  checkForcedChangePassword() {
    this.forcedChangePassword = localStorage.getItem("forcedChangePassword");
  }

  getMenuItems() {
    this.menuItemService.getMenuItemsByUser(this.user, this.role).subscribe(
      data => {
        if (getToken(data)) {
          data.menus.forEach(element => {
            this.menuItems.push(element.id.toString());
          });
        } else {
          this.logOut();
        }
      },
      error => {
        this.logOut();
      }
    )
  }

   getArticulos(articulos) {
    this.articulosGuardados = articulos;
  }

}
